"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _LabelWithIcon = _interopRequireDefault(require("../LabelWithIcon"));

var _FilePreviewList = _interopRequireDefault(require("../FilePreviewList"));

var _FileUploadWrapper = _interopRequireDefault(require("../FileUploadWrapper"));

require("./styles/_file-input.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FileInputSection = /*#__PURE__*/function (_Component) {
  _inherits(FileInputSection, _Component);

  function FileInputSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FileInputSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FileInputSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "deleteAsset", function (assetIndex) {
      return function () {
        var _this$props = _this.props,
            group = _this$props.group,
            updateGroup = _this$props.updateGroup;
        var assetIds = group.assetIds;
        assetIds.splice(assetIndex, 1);
        updateGroup(group);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleUploadClick", function () {
      if (_this._filePickerRef) {
        _this._filePickerRef.openFileChooser();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setFilePickerRef", function (ref) {
      if (ref && !_this._filePickerRef) {
        _this._filePickerRef = ref;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateGroupInputField", function (fieldName) {
      return function (result) {
        var _this$props2 = _this.props,
            group = _this$props2.group,
            updateGroup = _this$props2.updateGroup;
        group[fieldName] = (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result);
        updateGroup(group);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "addAssetId", function (assetId) {
      var _this$props3 = _this.props,
          group = _this$props3.group,
          updateGroup = _this$props3.updateGroup;
      updateGroup(_objectSpread({}, group, {
        assetIds: group.assetIds ? [].concat(_toConsumableArray(group.assetIds), [assetId]) : [assetId]
      }));
    });

    return _this;
  }

  _createClass(FileInputSection, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          _this$props4$group = _this$props4.group,
          name = _this$props4$group.name,
          assetIds = _this$props4$group.assetIds,
          notes = _this$props4$group.notes,
          groupType = _this$props4.groupType,
          placeHolder = _this$props4.placeHolder,
          notesPlaceholder = _this$props4.notesPlaceholder,
          acceptedFileTypes = _this$props4.acceptedFileTypes,
          openAssetModal = _this$props4.openAssetModal,
          buttonPrefix = _this$props4.buttonPrefix,
          type = _this$props4.type,
          isEditableTitle = _this$props4.isEditableTitle,
          isRemovable = _this$props4.isRemovable,
          deleteGroup = _this$props4.deleteGroup,
          subBrandId = _this$props4.subBrandId;
      return _react.default.createElement("section", null, _react.default.createElement("div", {
        className: "file-input__title"
      }, isEditableTitle ? _react.default.createElement(_uiKit.TitleBox, {
        title: name,
        titlePlaceHolder: placeHolder,
        onChangeTitle: this.updateGroupInputField('name'),
        editableTitle: isEditableTitle
      }) : _react.default.createElement(_LabelWithIcon.default, {
        label: name,
        labelClassName: "file-input__title__label"
      }), assetIds && assetIds.length !== 0 ? _react.default.createElement(_uiKit.Button, {
        type: "SECONDARY",
        small: true,
        onClick: this.handleUploadClick
      }, "UPLOAD MORE") : null), assetIds && assetIds.length !== 0 ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_FilePreviewList.default, {
        assetIds: assetIds,
        deleteAsset: this.deleteAsset,
        openAssetModal: openAssetModal,
        buttonTitle: "Edit Details",
        type: type
      }), notesPlaceholder ? [_react.default.createElement("div", {
        key: "notes-hr"
      }, _react.default.createElement("hr", null)), _react.default.createElement("div", {
        className: "file-input__notes",
        key: "notes-input"
      }, _react.default.createElement(_uiKit.Input, {
        className: "file-notes",
        multiline: true,
        label: "NOTES",
        placeholder: notesPlaceholder,
        defaultValue: notes || '',
        onChange: this.updateGroupInputField('notes')
      }))] : null) : null, _react.default.createElement(_FileUploadWrapper.default, {
        isVisible: assetIds ? assetIds.length === 0 : true,
        addAssetId: this.addAssetId,
        setFilePickerRef: this.setFilePickerRef,
        acceptedFileTypes: acceptedFileTypes,
        handleButtonClick: this.handleUploadClick,
        buttonPrefix: buttonPrefix,
        handleRemoveClick: deleteGroup,
        isRemovable: isRemovable,
        type: type,
        groupType: groupType,
        subBrandId: subBrandId
      }));
    }
  }]);

  return FileInputSection;
}(_react.Component);

var _default = FileInputSection;
exports.default = _default;